import { create } from 'zustand';

interface AdSubmissionFlowStore {
  isAdSubmitRedirect: boolean;
  setIsAdSubmitRedirect: (isRedirect: boolean) => void;
}

export const useAdSubmissionFlowStore = create<AdSubmissionFlowStore>(set => ({
  isAdSubmitRedirect: false,
  setIsAdSubmitRedirect: isRedirect => set({ isAdSubmitRedirect: isRedirect }),
}));
